import Form from "./form";

export { Form };

export const FormItem = Form.Item;
export const createForm = Form.create;
